export default __webpack_public_path__ + "static/media/ExperienceBackground.29e7bf4f.jpg";